import type { UnitInfoGrizzlyFeederInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';

export const INCLINATION_OPTIONS = [0, 6, 10];

export const MODELS = [
  'SV1152E',
  'SV1153E',
  'SV1252E',
  'SV1253E',
  'SV1652E',
  'SV1653E',
  'SV1852E',
  'SV1853E',
];

/* Returns the amount of decks for the model. If the last number equals 3 it has two decks, else one */
export const getNbrOfDecks = (modelName: string): number => {
  if (modelName.slice(-2, -1) === '3') {
    return 2;
  }
  return 1;
};

export const getDefaultData = (): UnitInfoGrizzlyFeederInterface => {
  return {
    modelName: MODELS[0],
    moisture: 0,
    newMoisture: false,
    decks: {
      0: { separationSize: 100, display: { separationSize: true } },
      1: { separationSize: 30, display: { separationSize: true } },
    },
    inclination: INCLINATION_OPTIONS[1],
    parallelUnits: 1,
    otherModel: false,
    otherModelMaxFeedSize: 0,
    otherModelNominalCapacity: 0,
    customModelTwoDecks: false,
    nbrOfOutputs: 2,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displayUnitName: true,
      displayModelName: true,
      displayInclination: false,
      displayLoad: true,
      displaySepSizeDeck1: true,
      displaySepSizeDeck2: true,
    },
  };
};

export class GrizzlyFeederSVEConfig extends BaseUnitConfig {
  static getDefaultData(): UnitInfoGrizzlyFeederInterface {
    return {
      modelName: MODELS[0],
      ...BaseUnitConfig.getBaseDefaults(),
      decks: {
        0: { separationSize: 100, display: { separationSize: true } },
        1: { separationSize: 30, display: { separationSize: true } },
      },
      inclination: INCLINATION_OPTIONS[1],
      otherModel: false,
      otherModelMaxFeedSize: 0,
      otherModelNominalCapacity: 0,
      customModelTwoDecks: false,
      nbrOfOutputs: 2,
      display: {
        ...BaseUnitConfig.getDefaultDisplay(),
        displayInclination: false,
        displayLoad: true,
        displaySepSizeDeck1: true,
        displaySepSizeDeck2: true,
      },
    };
  }

  static getNumberOfPorts(): number {
    return 3;
  }
}

export const grizzlyFeederSVEConfig = new GrizzlyFeederSVEConfig();
